export default __webpack_public_path__ + "static/media/swedish-furniture-store.a55b205e.svg";